<template>
    <v-container fluid>
        <iframe :src="source" />
    </v-container>
</template>

<script>
export default {
    computed: {
        source() {
            return process.env.NODE_ENV === "production"
                ? "https://drivers.ft207.nl "
                : "https://dev-drivers.ft207.nl";
        },
    },
};
</script>
<style>
iframe {
    width: 100%;
    height: calc(100vh - 110px - 40px);
    border-width: 0px !important;
    box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2),
        0 5px 8px 0 rgba(0, 0, 0, 0.14), 0 1px 14px 0 rgba(0, 0, 0, 0.12) !important;
}
</style>
